import { render, staticRenderFns } from "./Checkboxes.vue?vue&type=template&id=48b2bd63&scoped=true"
import script from "./Checkboxes.vue?vue&type=script&lang=js"
export * from "./Checkboxes.vue?vue&type=script&lang=js"
import style0 from "./Checkboxes.vue?vue&type=style&index=0&id=48b2bd63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b2bd63",
  null
  
)

export default component.exports